import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  position: {
    default: '',
    editor: 'dropdown',
    editorOptions: [
      '',
      'bottom',
      'bottom-left',
      'bottom-middle',
      'bottom-right',
      'top',
      'top-left',
      'top-middle',
      'top-right',
    ],
  },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'Playground where you can render alerts in any corner of the screen',
  coreComponent_v3: {
    html: `<tag3-mobile-toast {{...knobs}}>
  <tag3-mobile-alert
    text='Something went even more wrong!'
    closeable
    close-transition='slideDown'
    show-duration='0'>
  </tag3-mobile-alert>
  <tag3-mobile-alert
    text='Something went a bit more wrong!'
    closeable
    close-transition='slideDown'
    show-duration='0'>
  </tag3-mobile-alert>
  <tag3-mobile-alert
    text='Something went a bit wrong!'
    closeable
    close-transition='slideDown'
    show-duration='0'>
  </tag3-mobile-alert>
</tag3-mobile-toast>`,
    knobs: { ...PlaygroundKnobs },
  },
  reactWrapper_v3: {
    jsx: `<TagMobileToast {{...knobs}}>
  <TagMobileAlert
    text='Something went a bit wrong!'
    showDuration={0}
    closeable
    closeTransition='slideDown'>
  </TagMobileAlert>
  <TagMobileAlert
    text='Something nearly went a bit wrong!'
    showDuration={0}
    closeable
    closeTransition='slideDown'>
  </TagMobileAlert>
  <TagMobileAlert
    text='Something went well!'
    showDuration={0}
    closeable
    closeTransition='slideDown'>
  </TagMobileAlert>
</TagMobileToast>`,
    knobs: { ...PlaygroundKnobs },
  },
};
export const TagMobileToastDocs: Component = {
  type: 'component',
  name: 'mobile-toast',
  description: 'Renders a container for alerts that can be shown in the corners of the screen',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'position',
      description: 'The position to display the toast',
      type: 'bottom | bottom-left | bottom-right | top | top-left | top-right',
      default: 'bottom-right',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
